export default __webpack_public_path__ + "static/media/19_SchererGruppe-DTM-Documentary-EschweilerPhotography_M1A3277.bdb34cc2.jpg";